import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const consultApi = axios.create({ baseURL: `${BASE}/api/consult`, withCredentials: true });

consultApi.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("rhm_customer_token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
});

export const consultError = (e) => {
    const d = e?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg).join(" ");
    return e?.message || "Something went wrong";
};

export const SELECTION_KEY = "rhm_consult_selection";
